import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: var(--spacing-md) 0;
  border-top: 1px solid var(--color-divider);
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  text-align: center;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <p>© {currentYear} TranscriptGen. All rights reserved.</p>
    </FooterContainer>
  );
};

export default Footer;